// button ===========================================

$(function () {
  $(".custom_button a, .custom_button_dark a, .customs_button button, button.customs_button")
    .on("mouseenter", function (e) {
      var parentOffset = $(this).offset(),
        relX = e.pageX - parentOffset.left,
        relY = e.pageY - parentOffset.top;
      $(this).find("span").css({ top: relY, left: relX });
    })
    .on("mouseout", function (e) {
      var parentOffset = $(this).offset(),
        relX = e.pageX - parentOffset.left,
        relY = e.pageY - parentOffset.top;
      $(this).find("span").css({ top: relY, left: relX });
    });

  $("button.custom_button")
    .on("mouseenter", function (e) {
        var parentOffset = $(this).offset(),
            relX = e.pageX - parentOffset.left,
            relY = e.pageY - parentOffset.top;
        $(this).find(".line_bg").css({ top: relY, left: relX });
    })
    .on("mouseout", function (e) {
        var parentOffset = $(this).offset(),
            relX = e.pageX - parentOffset.left,
            relY = e.pageY - parentOffset.top;
        $(this).find(".line_bg").css({ top: relY, left: relX });
    });
});

// cursor_effect & cm_product_sliders  ==================================

$(document).ready(function () {
  var cursor = $(".Custom-cursor");

  $(document).on("mousemove", function (e) {
    cursor.css({
      left: e.clientX - cursor.width() / 2,
      top: e.clientY - cursor.height() / 2,
    });
  });

  $(".product_slider_block, .image_slider_main").on("mouseenter", ".swiper-wrapper", function () {
    cursor.addClass("active");
  });

  $(".product_slider_block, .image_slider_main").on("mouseleave", ".swiper-wrapper", function () {
    cursor.removeClass("active");
  });

  $(".product_slider_block, .image_slider_main").on("mouseenter", ".swiper-button-next, .swiper-button-prev, .customs_button, .quick-add__submit, a.link-btn", function () {
    cursor.addClass("disable");
  });

  $(".product_slider_block, .image_slider_main").on("mouseleave", ".swiper-button-next, .swiper-button-prev, .customs_button, .quick-add__submit, a.link-btn", function () {
    cursor.removeClass("disable");
  });
});

var swiper_cm_product_sliders = new Swiper(".cm_product_sliders", {
    slidesPerView: 1.2,
    spaceBetween: 20,
  lazy: true,
      navigation: {
        nextEl: ".cm_product_sliders .swiper-button-next",
        prevEl: ".cm_product_sliders .swiper-button-prev",
      },
      pagination: {
          el: '.cm_product_sliders .swiper-pagination',
          clickable: true,
        },
     breakpoints: {
      1379: {
        slidesPerView: 3,
        spaceBetween: 40
      },
      950: {
        slidesPerView: 2.3,
        spaceBetween: 20
      },
      767: {
        slidesPerView: 2.2,
        spaceBetween: 20
      },     
      320: {
        slidesPerView: 1.2,
        spaceBetween: 20
      }
    }
});


// result_slider ===================================

var swiper_results_slider = new Swiper(".results_slider", {
  spaceBetween: 24,
  pagination: {
    el: ".cm_real_results .swiper-pagination",
    type: "progressbar",
  },
  navigation: {
    nextEl: ".cm_real_results .swiper-button-next",
    prevEl: ".cm_real_results .swiper-button-prev",
  },
 breakpoints: {
    992: {
      slidesPerView: 3.4
    },
   790: {
      slidesPerView: 2.9,
      spaceBetween: 12,
    },
   576: {
      slidesPerView: 2.3,
      spaceBetween: 12,
    },
   320: {
      slidesPerView: 1.1,
      spaceBetween: 14,
    }
  }
});

// video =============================================

document.addEventListener("DOMContentLoaded", function () {
  var desktopVideo = document.getElementById("desktopVideo");
  var desktopPlayBtn = document.getElementById("desktopPlayBtn");
  var desktopPauseBtn = document.getElementById("desktopPauseBtn");

  function togglePlayPause(video, playBtn, pauseBtn) {
    if (video.paused) {
      video.play();
      playBtn.style.display = "none";
      pauseBtn.style.display = "block";
    } else {
      video.pause();
      playBtn.style.display = "block";
      pauseBtn.style.display = "none";
    }
  }

  if (desktopPlayBtn && desktopPauseBtn && desktopVideo) {
    desktopPlayBtn.addEventListener("click", function () {
      togglePlayPause(desktopVideo, desktopPlayBtn, desktopPauseBtn);
    });

    desktopPauseBtn.addEventListener("click", function () {
      togglePlayPause(desktopVideo, desktopPlayBtn, desktopPauseBtn);
    });

    desktopVideo.addEventListener("play", function () {
      desktopPlayBtn.style.display = "none";
      desktopPauseBtn.style.display = "block";
    });

    desktopVideo.addEventListener("pause", function () {
      desktopPlayBtn.style.display = "block";
      desktopPauseBtn.style.display = "none";
    });
  }
});

// custom_product =============================================

document.addEventListener("DOMContentLoaded", function () {
  var swiperThumbs = new Swiper(".mySwiper", {
    spaceBetween: 0,
    slidesPerView: 1,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });

  var swiperMain = new Swiper(".mySwiper2", {
    spaceBetween: 0,
    slidesPerView: 1,
    navigation: {
      nextEl: ".swiper-button-next-custom",
      prevEl: ".swiper-button-prev-custom",
    },
    thumbs: {
      swiper: swiperThumbs,
    },
    on: {
      slideChange: function () {
        updateSlideCounter(swiperMain);
        swiperThumbs.slideTo(swiperMain.realIndex); // Update swiperThumbs when swiperMain changes
      },
    },
  });

  swiperThumbs.on("slideChange", function () {
    swiperMain.slideTo(swiperThumbs.realIndex);
  });

  function updateSlideCounter(swiper) {
    var currentSlide = document.querySelector(".current-slide");
    var totalSlides = document.querySelector(".total-slides");
    if(currentSlide){
    currentSlide.textContent = swiper.realIndex + 1;
    }
    if(totalSlides){
    totalSlides.textContent = swiper.slides.length;
    }
  }

  // Initial update of slide counter
  updateSlideCounter(swiperMain);
});

// tabbed_section ==============================================

document.addEventListener("DOMContentLoaded", function () {
  const titles = document.querySelectorAll(".tabbed_title");
  const items = document.querySelectorAll(".tabbed_item");

  titles.forEach((title) => {
    title.addEventListener("mouseover", function () {
      const index = this.getAttribute("data-index");

      items.forEach((item) => item.classList.remove("active"));
      titles.forEach((title) => title.classList.remove("active"));

      this.classList.add("active");
      items[index].classList.add("active");
    });
  });
});

// pillars_section ============================================

 var swiper_pillers_slider = new Swiper(".pillers_slider", {
      slidesPerView: 1,
      spaceBetween: 40,
      breakpoints: {
      1200: {
        slidesPerView: 4
      },
     992: {
        centeredSlides: true,
        slidesPerView: 1.5,
        spaceBetween: 25,
      },
     576: {
        centeredSlides: true,
        slidesPerView: 1.5,
        spaceBetween: 12,
      },
     300: {
        centeredSlides: true,
        slidesPerView: 1.2,
        spaceBetween: 12,
      }
    }
});



// header product
document.addEventListener('DOMContentLoaded', function() {
  // const titles = document.querySelectorAll('.collection_title');
  // const productDetails = document.querySelectorAll('.product_tab_details');
  
  // let activeTabId = null;

  // function showProductDetails(tabId) {
  //   productDetails.forEach(detail => {
  //     if (detail.getAttribute('id') === tabId) {
  //       detail.classList.add('active');
  //     } else {
  //       detail.classList.remove('active');
  //     }
  //   });
  // }

  // function activateTitle(title) {
  //   titles.forEach(t => t.classList.remove('active'));
  //   title.classList.add('active');
  // }

  // titles.forEach(title => {
  //   title.addEventListener('mouseover', function() {
  //     activeTabId = this.getAttribute('data-tab');
  //     showProductDetails(activeTabId);
  //     activateTitle(this);
  //   });
  // });

  // productDetails.forEach(detail => {
  //   detail.addEventListener('mouseover', function() {
  //     activeTabId = this.getAttribute('id');
  //     showProductDetails(activeTabId);
  //     titles.forEach(title => {
  //       if (title.getAttribute('data-tab') === activeTabId) {
  //         activateTitle(title);
  //       }
  //     });
  //   });

  //   detail.addEventListener('mouseout', function() {
  //     setTimeout(() => {
  //       if (!document.querySelector('.collection_title:hover') && !document.querySelector('.product_tab_details:hover')) {
  //         activeTabId = null;
  //         showProductDetails('');
  //       }
  //     }, 100);
  //   });
  // });

  // // Handle mouseout for the entire section
  // document.querySelector('.header_pr_slider_main').addEventListener('mouseout', function(event) {
  //   if (!event.target.closest('.collection_title') && !event.target.closest('.product_tab_details')) {
  //     activeTabId = null;
  //     showProductDetails('');
  //   }
  // });

var colProSwiper = new Swiper(".featured_collection_slider", {
  loop: true,
  autoHeight: true,
  allowTouchMove: false
});
var colProSwiper2 = new Swiper(".featured_collection_slider_2", {
  loop: true,
  autoHeight: true,
  allowTouchMove: false
});

$('.collection_title').hover(function() {
  var index = $(this).data('tab-index') - 1;
  colProSwiper.slideToLoop(index);
  colProSwiper2.slideToLoop(index);
  

  $('.collection_title').removeClass('active');
  $(this).addClass('active');
});

  



  });

// Variable to hold the Swiper instance
let swiperNewArrival;

// Function to initialize Swiper
function initializeSwiper() {
  swiperNewArrival = new Swiper('.new_arrival_wrapper', {
    loop: false,
    slidesPerView: 4,
    spaceBetween: 10,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      1200: {
        slidesPerView: 4,
      },
      992: {
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 2,
      },
      576: {
        slidesPerView: 1,
      },
    },
  });
}

// Function to destroy Swiper
function destroySwiper() {
  if (swiperNewArrival) {
    swiperNewArrival.destroy(true, true);
    swiperNewArrival = null;
  }
}

// Function to handle window resize
function handleResize() {
  const screenWidth = window.innerWidth;

  if (screenWidth >= 992) {
    if (!swiperNewArrival) {
      initializeSwiper();
    }
  } else {
    destroySwiper();
  }
}

// Initial check
handleResize();

// Add event listener for window resize
window.addEventListener('resize', handleResize);


// window scroll add & remove class in body==================

$(document).ready(function() {
var lastScrollTop = 0;
var scrollThreshold = 5; 
$(window).scroll(function() {
    var currentScrollTop = $(this).scrollTop();

    if (currentScrollTop - lastScrollTop > scrollThreshold) {
        
        if (!$('body').hasClass('new_header_class')) {
            $('body').addClass('new_header_class');
        }
    } else if (lastScrollTop - currentScrollTop > scrollThreshold) {
        
        if ($('body').hasClass('new_header_class')) {
            $('body').removeClass('new_header_class');
        }
    }

    lastScrollTop = currentScrollTop;
  });
});

// add class in body==================

$(document).ready(function() {
  $('.form__label span').click(function() {
    $('body').toggleClass('popup_class');
  });
});

// product page accordion =====================

$(document).ready(function(){
  $(document).on('click','.accordion_question', function(){
    var currentContent = $(this).next('.accordion__content');
    $('.accordion__content').not(currentContent).slideUp().prev('.accordion_question').find('.accordion_icon').removeClass('active');
    currentContent.slideToggle();
    $(this).find('.accordion_icon').toggleClass('active');
  })  
});


// mac class add ================

if (navigator.userAgent.match(/(iPod|iPhone|iPad|Mac)/)) {
jQuery('body').addClass('mac');
}


// product page progressbar ===============

var productSwiper = null;
var thumbnailSwiper = null;

  function createSlider() {
    if (window.innerWidth <= 749) {
      if (!productSwiper) {
        productSwiper = new Swiper(".productSwiper", {
          slidesPerView: 1.05,
          speed: 300, // Adjust transition speed as needed
          effect: "slide", // Use 'slide' effect for smooth transitions
          on: {
            slideChange: function () {
            if (this.activeIndex === 0) {
            this.params.slidesPerView = 1.05;
            } else {
            this.params.slidesPerView = 1;
            }
            this.update();
            },
          },
          pagination: {
            el: ".productSwiper .swiper-pagination",
            clickable: true,
            speed: 20000,
          },
        });
      }

      if (!thumbnailSwiper) {
        thumbnailSwiper = new Swiper(".thumbnail-slider", {
          slidesPerView: 'auto',
          freeMode: true,
          pagination: {
            el: ".thumbnail-slider .swiper-pagination",
            clickable: true,
          },
          speed: 20000,
        });
      }
    } else {
      if (productSwiper) {
        productSwiper.destroy(true, true);
        productSwiper = null;
      }

      if (thumbnailSwiper) {
        thumbnailSwiper.destroy(true, true);
        thumbnailSwiper = null;
      }
    }
  }
  createSlider();
  window.addEventListener("resize", createSlider);

// var productSwiper = null;
// var thumbnailSwiper = null;

// function createSlider() {
//   if (document.innerWidth <= 749) {
//     console.log('cread')
//     if (!productSwiper) {
//       productSwiper = new Swiper(".productSwiper", {
//         slidesPerView: 1, // Set initial value to 1
//         on: {
//           slideChange: function () {
//             // Adjust slidesPerView based on activeIndex
//             this.params.slidesPerView = this.activeIndex === 0 ? 1 : 1;
//             this.update(); // Update the slider to apply changes
//           },
//           init: function () {
//             // Check activeIndex and adjust slidesPerView during initialization
//             this.params.slidesPerView = this.activeIndex === 0 ? 1 : 1;
//             this.update(); // Update the slider to apply changes
//           },
//         },
//         pagination: {
//           el: ".productSwiper .swiper-pagination",
//           clickable: true,
//         },
//         speed: 20000,
//       });
//     }

//     if (!thumbnailSwiper) {
//       thumbnailSwiper = new Swiper(".thumbnail-slider", {
//         slidesPerView: 'auto',
//         freeMode: true,
//         pagination: {
//           el: ".thumbnail-slider .swiper-pagination",
//           clickable: true,
//         },
//         speed: 20000,
//       });
//     }
//   } else {
//     if (productSwiper) {
//       productSwiper.destroy(true, true);
//       productSwiper = null;
//     }

//     if (thumbnailSwiper) {
//       thumbnailSwiper.destroy(true, true);
//       thumbnailSwiper = null;
//     }
//   }
// }

// createSlider();
// document.addEventListener("resize", createSlider);


//============================ swatch color active

const currentPath = window.location.pathname;
const swatchLabels = document.querySelectorAll('.swatch-input__label');

swatchLabels.forEach(label => {
const anchor = label.querySelector('a');
if (anchor) {

const href = anchor.getAttribute('href');
if (href && href === currentPath) {

  label.classList.add('active');
}
}
});


// $(document).ready(function() {
//   // Function to check if an element is in the viewport
//   function isElementInViewport(el) {
//     var rect = el.getBoundingClientRect();
//     return (
//       rect.top >=  300 &&
//       rect.left >= 0 &&
//       rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
//       rect.right <= (window.innerWidth || document.documentElement.clientWidth)
//     );
//   }

//   // Function to check if an element has exited the viewport from the bottom
//   function hasElementExitedViewport(el) {
//     var rect = el.getBoundingClientRect();
//     return rect.bottom < 0;
//   }

//   // Check on scroll and on initial load
//   $(window).on('scroll load', function() {
//     $('.image_slider_sec').each(function() {
//       var $this = $(this);

//       if (isElementInViewport(this) && !$this.hasClass('activee')) {
//         $this.addClass('activee');
//       }
//     });
//   });
// });

var call_once = false;

window.initFreeshippingGoal = function initFreeshippingGoal(parsedState) {

  const freeShippingConfig = window.freeShippingConfig || {};
  if (freeShippingConfig.enable) {
    var goal = freeShippingConfig.goal_amt;
    var ShopifyCurrency = Shopify.currency || {};
    var rate = Number(ShopifyCurrency ? ShopifyCurrency.rate || 1 : 1);
    var goalConverted = Number(goal || 1) * rate * 100 / 100;
    var subtotal = Number(parsedState.total_price) / 100;
    var msg1Text = freeShippingConfig.goal_amt_msg_1;
    var msg2Text = freeShippingConfig.goal_amt_msg_2;
    var progress = 0, msg = '';
    var freeShippingGoalHtml = '';
  
    var wrapperWidth = $('[data-free-shipping-goal-section]').outerWidth();
    
    if (subtotal > 0 && subtotal < goalConverted) {
        progress = parseInt((subtotal * 100) / goalConverted);
        msg = msg1Text.replace('{{amount}}', (goalConverted-subtotal));
          
    } else if (subtotal > 0 && subtotal >= goalConverted) {
        progress = 100;
        msg = '🎉 ' + msg2Text;
    }else{
      progress = parseInt((subtotal * 100) / goalConverted);
      msg = msg1Text.replace('{{amount}}', (goalConverted-subtotal));
    }

    setTimeout(function() {
      if(progress == 100){
        if(document.querySelector('.cart-drawer__footer .saved-badge') && !document.querySelector('.cart-drawer__footer .saved-badge span.free-ship-text')){
          document.querySelector('.cart-drawer__footer .saved-badge').innerHTML += '<span class="free-ship-text">+ free shipping</span>';
        }else{
          if(document.querySelector('.cart-drawer__footer .saved-badge') == null && !document.querySelector('.cart-drawer__footer .saved-badge span.free-ship-text')){
            document.querySelector('.cart-drawer__footer .tax-note').innerHTML += '<div class="saved-badge"><span class="free-ship-text">free shipping</span></div>';
          }
        }
        //document.querySelector('.offer-text') && document.querySelector('.offer-text').classList.remove('hidden');
      }else{
        if(document.querySelector('.cart-drawer__footer .saved-badge span')){
          if(document.querySelector('.cart-drawer__footer .saved-badge .rm-lable')){
            document.querySelector('.cart-drawer__footer .saved-badge span.free-ship-text') && document.querySelector('.cart-drawer__footer .saved-badge span.free-ship-text').remove();  
          }else{
            document.querySelector('.cart-drawer__footer .saved-badge').remove();
          }
        }
        // if(document.querySelector('.saved-badge') == null){
        //   document.querySelector('.offer-text') && document.querySelector('.offer-text').classList.add('hidden');
        // }
      }
      if(document.querySelector('.cart-drawer__footer .saved-badge') == null){
        document.querySelector('.cart-drawer__footer .offer-text') && document.querySelector('.cart-drawer__footer .offer-text').classList.add('hidden');
      }else{
        if(document.querySelector('.cart-drawer__footer .saved-badge')){
          document.querySelector('.cart-drawer__footer .offer-text') && document.querySelector('.cart-drawer__footer .offer-text').classList.remove('hidden');  
        }else{
          if(progress == 100){
            document.querySelector('.cart-drawer__footer .offer-text') && document.querySelector('.cart-drawer__footer .offer-text').classList.remove('hidden');  
          }else{
            document.querySelector('.cart-drawer__footer .offer-text') && document.querySelector('.cart-drawer__footer .offer-text').classList.add('hidden');  
          }
        }
      }
    }, 1000);
    
    
    
      var freeShippingGoalHtml = `<div data-item="freeshipping-goal" class="cart-goal">
          <div class="cart-goal__inner">
              <div class="cart-goal__bar">
                  <span><span class="goal-badge">${progress}</span></span>
              </div>
          </div>
          <div class="cart-goal-msg">${msg}</div>
      </div>`;

    $('[data-free-shipping-goal-section]').each(function() {
        $(this).removeClass('hidden');
        var _this = $(this);
        if (freeShippingGoalHtml == '') {
            _this.html('');
        } else {
            if (_this.find('[data-item="freeshipping-goal"]').length) {
                if(progress.toString() != 'NaN'){
                  var progressCounterStart = $('.cart-goal__bar span.goal-badge', _this).text();
                  _this.find('[data-item="freeshipping-goal"] .cart-goal-msg').html(msg);
                  $('.cart-goal__bar span.goal-badge', _this).text(progress);
                  var timeOut = 250;  
                }
            } else {
                if(progress.toString() != 'NaN'){
                  _this.html(freeShippingGoalHtml);
                  $('.cart-goal__bar span.goal-badge', _this).text(progress);
                  var progressCounterStart = 0;
                  var timeOut = 0;
                }
            }

            setTimeout(function() {
                _this.prop('Counter', progressCounterStart).animate({
                    Counter: $('.cart-goal__bar span.goal-badge', _this).text()
                }, {
                    duration: 1,
                    easing: 'linear',
                    step: function (now) {
                        $('.cart-goal__bar span:not(.goal-badge)', _this)[0].style.setProperty('--progress', Math.ceil(now) + '%')
                    }
                });
            }, timeOut);
        }
    });
  }
}

window.initFreegiftGoal = function initFreegiftGoal(parsedState) {

  var cart_obj = JSON.parse((document.querySelector('.cart-json-cart') || document.querySelector('.cart-json')).innerText);
  var check_gift_status = false;
  var gift_obj = {};
  if(cart_obj.items.length > 0){
    for(var i=0;i<cart_obj.items.length;i++){
      if(cart_obj.items[i].properties['_gift']){
        check_gift_status = true;
        gift_obj = cart_obj.items[i];
        break;
      }
    }
  }

  const freeShippingConfig = window.freeShippingConfig || {};
  if (freeShippingConfig.enablegift) {
    var goal = freeShippingConfig.goal_amt;
    var ShopifyCurrency = Shopify.currency || {};
    var rate = Number(ShopifyCurrency ? ShopifyCurrency.rate || 1 : 1);
    var goalConverted = Number(goal || 1) * rate * 100 / 100;
    var subtotal = Number(cart_obj.total_price) / 100;
    console.log(subtotal,'subtotal');
    var msg1Text = freeShippingConfig.freegift_goal_msg_1;
    var msg2Text = freeShippingConfig.freegift_goal_msg_2;
    var progress = 0, msg = '';
    var freeShippingGoalHtml = '';
  
    var wrapperWidth = $('[data-free-shipping-goal-section]').outerWidth();
    
    if (subtotal > 0 && subtotal < goalConverted) {
        progress = parseInt((subtotal * 100) / goalConverted);
        msg = msg1Text.replace('{{amount}}', (goalConverted - subtotal));
    } else if (subtotal > 0 && subtotal >= goalConverted) {
        progress = 100;
        msg = '🎉 ' + msg2Text;
    }else{
      progress = parseInt((subtotal * 100) / goalConverted);
      msg = msg1Text.replace('{{amount}}', (goalConverted - subtotal));
    }
    
    
    
    var freeShippingGoalHtml = `<div data-item="freeshipping-goal" class="cart-goal">
        <div class="cart-goal__inner">
            <div class="cart-goal__bar">
                <span><span class="goal-badge">${progress}</span></span>
            </div>
        </div>
        <div class="cart-goal-msg">${msg}</div>
    </div>`;

    var check_visit = false;
    var check_remove = false;
    $('[data-free-shipping-goal-section]').each(function() {
      
        $(this).removeClass('hidden');
        var _this = $(this);
        if (freeShippingGoalHtml == '') {
            _this.html('');
        } else {
            if (_this.find('[data-item="freeshipping-goal"]').length) {
                var cart = document.querySelector("cart-drawer");
                var cart_section = document.querySelector("cart-drawer-items");
                if(window.freeShippingConfig.template == 'cart'){
                  cart = document.querySelector("cart-items");
                  cart_section = document.querySelector("cart-items");
                }
                
                var progressCounterStart = $('.cart-goal__bar span.goal-badge', _this).text();
                _this.find('[data-item="freeshipping-goal"] .cart-goal-msg').html(msg);
                $('.cart-goal__bar span.goal-badge', _this).text(progress);

                // console.log(progress,'progress');

                if(call_once == false){
                  
                  if(check_gift_status == false && progress == 100 && check_visit == false){
                    /*if(call_once == true){
                      return;
                    }*/
                    call_once = true;
                    
                    check_visit = true;
                    if(Object.entries(gift_obj).length > 0){
                      return;
                    }
                    fetch("/cart/add.js", {
                      method: "POST",
                      headers: {
                          "Content-Type": "application/json",
                      },
                      body: JSON.stringify({
                        quantity: 1,
                        id: window.freeShippingConfig.giftproduct,
                        properties: {
                          "_gift":true
                        },
                        sections: cart_section.getSectionsToRender().map((section) => section.section),
                        sections_url: window.location.pathname
                      }),
                    }).then(response => {
                      if (!response.ok) {
                        throw new Error('Network response was not ok');
                      }
                      return response.json();
                    }).then(result => {
                        if(window.freeShippingConfig.template == 'cart'){
                          cart.getSectionsToRender().forEach((section) => {
                            const elementToReplace =
                              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                            elementToReplace.innerHTML = cart.getSectionInnerHTML(
                              result.sections[section.section],
                              section.selector
                            );
                          });
                        }else{
                          cart.renderContents(result);
                        }
                      
                        // console.log('Added',result);
                    }).catch(error => {
                        console.error('There was a problem with the fetch operation:', error);;
                    }).finally(() => {
                      //console.log('finally');
                      call_once = false;
                    });  
                  }else if(check_gift_status == true && progress < 100 && check_remove == false && Object.entries(gift_obj).length > 0){
  
                    /* if(call_once == true){
                      return;
                    }*/
                    call_once = true;
                    
                    let updates = {};
                    if(document.querySelector('.gift-prod')){
                      var update_key = document.querySelector('.gift-prod').getAttribute('data-id')
                    }else{
                      return;
                    }
                    var remove_key = update_key;
                    updates[remove_key] = 0;
  
                    fetch("/cart/update.js", {
                      method: "POST",
                      headers: {
                          "Content-Type": "application/json",
                      },
                      body: JSON.stringify({
                        updates,
                        sections: cart_section.getSectionsToRender().map((section) => section.section),
                        sections_url: window.location.pathname
                      }),
                    }).then(response => {
                      if (!response.ok) {
                        throw new Error('Network response was not ok');
                      }
                      return response.json();
                    }).then(result => {
                        // console.log('result2',result)
                        check_remove = true;
                        if(window.freeShippingConfig.template == 'cart'){
                          cart.getSectionsToRender().forEach((section) => {
                            const elementToReplace =
                              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                            elementToReplace.innerHTML = cart.getSectionInnerHTML(
                              result.sections[section.section],
                              section.selector
                            );
                          });
                          if(result.item_count === 0){
                            document.querySelector('#main-cart-footer').classList.add('is-empty');
                            document.querySelector('cart-items').classList.add('is-empty');
                            window.initFreegiftGoal(result);
                          }
                        }else{
                          cart.renderContents(result);
                          if(result.item_count === 0){
                            document.querySelector('cart-drawer').classList.add('is-empty');
                            window.initFreegiftGoal(result);
                          }
                        }
                      
                        //console.log('removed',result);
                    }).catch(error => {
                        console.error('There was a problem with the fetch operation:', error);;
                    }).finally(() => {
                      //console.log('finally');
                      call_once = false;
                    });
                  }
                }
                var timeOut = 250;
            } else {
                _this.html(freeShippingGoalHtml);
                $('.cart-goal__bar span.goal-badge', _this).text(progress);
                var progressCounterStart = 0;
                var timeOut = 0;
            }

            

            setTimeout(function() {
                _this.prop('Counter', progressCounterStart).animate({
                    Counter: $('.cart-goal__bar span.goal-badge', _this).text()
                }, {
                    duration: 1,
                    easing: 'linear',
                    step: function (now) {
                        $('.cart-goal__bar span:not(.goal-badge)', _this)[0].style.setProperty('--progress', Math.ceil(now) + '%')
                    }
                });
            }, timeOut);
        }
    });
  }
}

function addtocartItem(element){
  var v_flavour = element.closest('.upcell-item-content').querySelector('.upcell-item-variant-selector').value;
  if(v_flavour == "no-select"){
    element.closest('.upcell-item-content').querySelector('.upcell-item-selector').style.border = "1px solid red";
    //var get_error_msg = element.closest('.upcell-item-content').querySelector('.upcell-item-selector').querySelector('label').textContent;
    var errorMsg = document.createElement("span");
    errorMsg.classList.add('err-msg');
    //errorMsg.textContent = 'Please ' + get_error_msg;
    //element.closest('.upcell-item-content').querySelector('.box-select-div').appendChild(errorMsg);
    return;
  }
  var cart = document.querySelector("cart-drawer");
  var cart_section = document.querySelector("cart-drawer-items");
  if(window.freeShippingConfig.template == 'cart'){
    cart = document.querySelector("cart-items");
    cart_section = document.querySelector("cart-items");
  }
  var v_id = parseInt(element.getAttribute('data-variant-id'));
  
  // if(element.closest('.upcell-item-content').querySelector('.upcell-item-variant-selector')){
  //   v_id = parseInt(element.closest('.upcell-item-content').querySelector('.upcell-item-variant-selector').value);
  // }
  fetch("/cart/add.js", {
    method: "POST",
    headers: {
        "Content-Type": "application/json",
    },
    body: JSON.stringify({
      quantity: 1,
      id: v_id,
      properties: {
        "Flavor":v_flavour
      },
      sections: cart_section.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    }),
  }).then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json();
  }).then(result => {
      if(window.freeShippingConfig.template == 'cart'){
        cart.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = cart.getSectionInnerHTML(
            result.sections[section.section],
            section.selector
          );
        });
      }else{
        cart.renderContents(result);
      }
  }).catch(error => {
      console.error('There was a problem with the fetch operation:', error);;
  }).finally(() => {
    //console.log('finally');
  }); 
}

function changeData(element){
    element.options[0].disabled = true;
    if(element.closest('.box-select-div').querySelector('.err-msg')){
      element.closest('.box-select-div').querySelector('.err-msg').remove();
    }
    const computedStyle = window.getComputedStyle(element.closest('.upcell-item-selector')); 
    const borderColor = computedStyle.getPropertyValue('border-color');
    if(borderColor === 'red' || borderColor === 'rgb(255, 0, 0)' || borderColor === '#ff0000'){
      element.closest('.upcell-item-selector').style.border = '1px solid #767676';
    }
    var selected_option = element.options[element.selectedIndex];
    var image_data = selected_option.getAttribute('data-img'),
      title_data = selected_option.getAttribute('data-title'),
      price_data = selected_option.getAttribute('data-price'),
      pricec_data = selected_option.getAttribute('data-cprice'),
      link_data = selected_option.getAttribute('data-link'),
      pid_data = selected_option.getAttribute('data-v-id'),
      bg_color_data = selected_option.getAttribute('data-bg-color');
    
      element.closest('.upcell-item-inner').querySelector('.upcell-item-image img').setAttribute('src',image_data);
      element.closest('.upcell-item-inner').querySelector('.upcell-item-content .upcell-item-title a').innerText = title_data;
      element.closest('.upcell-item-inner').querySelector('.upcell-item-content .upcell-item-title a').setAttribute('href',link_data);
      element.closest('.upcell-item-inner').querySelector('.upcell-item-content .upcell-item-form button .regular-uprice').innerText = price_data;
      element.closest('.upcell-item').style.backgroundColor = bg_color_data;
      element.closest('.upcell-item-inner').querySelector('.upcell-item-content .upcell-item-form button').setAttribute('data-variant-id',pid_data);
    
      if(pricec_data == 'no'){
        element.closest('.upcell-item-inner').querySelector('.upcell-item-content .upcell-item-form button .compare-uprice').classList.add('hidden');
      }else{
        element.closest('.upcell-item-inner').querySelector('.upcell-item-content .upcell-item-form button .compare-uprice').classList.remove('hidden');
        element.closest('.upcell-item-inner').querySelector('.upcell-item-content .upcell-item-form button .compare-uprice').innerText = pricec_data;
      }
      // console.log(pid_data,element.value,element.selectedIndex,selected_option.value,image_data,title_data,price_data,bg_color_data,'inFunction',element.closest('.upcell-item-inner'),element.querySelector('option[value="'+element.value+'"]').getAttribute('data-title'));
  }

// if (window.freeShippingConfig.template == 'cart') {
//     fetch(window.Shopify.routes.root + 'cart.js').then((response) => response.json()).then((parsedState) => {
//         initFreeshippingGoal(parsedState);
//     }).catch((e) => {
//         console.error(e);
//     });
//   }






